import { memo } from 'react';

import { LinearProgress, type SxProps, type Theme } from '@mui/material';

import { varAlpha } from 'src/theme/styles';

const PROGRESS_HEIGHT = 4;
const PROGRESS_RADIUS = 16;

const progressBarSx: SxProps<Theme> = {
  flex: 1,
  height: PROGRESS_HEIGHT,
  borderRadius: PROGRESS_RADIUS,
  bgcolor: (theme) => varAlpha(theme.vars.palette.text.primaryChannel, 0.3),
  '& .MuiLinearProgress-bar': {
    bgcolor: 'text.primary',
    borderRadius: PROGRESS_RADIUS,
  },
};

interface ProgressLinearProps {
  value?: number;
  sx?: SxProps<Theme>;
}

export const ProgressLinear = memo(({ value, sx }: ProgressLinearProps) => (
  <LinearProgress
    variant={value !== undefined ? 'determinate' : 'indeterminate'}
    value={value}
    color="inherit"
    sx={{ ...progressBarSx, ...sx }}
  />
));

ProgressLinear.displayName = 'ProgressLinear';

export const getProgressPercent = (value?: number, current?: number, total?: number) => {
  if (value !== undefined) {
    return Math.min(100, Math.max(0, Math.round(value)));
  }

  if (current !== undefined && total !== undefined && total > 0) {
    return Math.min(100, Math.max(0, Math.round((current / total) * 100)));
  }

  return undefined;
};
